import React, {FC, useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {Box, IconButton, Stack, Typography, Checkbox} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import Collapse from '@mui/material/Collapse';
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IosShareIcon from '@mui/icons-material/IosShare';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {exportFloorPlan} from "../../../api/fairs";
import {createToastNotification} from "../../../utilities/helpers";
import {deleteFloorPlan} from "../../../api/hall";
import ConfirmationModal from "../../../components/ConfirmationModal";
import {fetchFloorPlan} from "../../../api/floor-plans";


export const FairFloorPlanRow: FC<{
    resetTrigger:boolean,
    hallWithFloorPlans: any,
    fetchFairDetails: () => void,
    setOpenFloorPlanModal: (open: boolean) => void,
    setSelectedFloorPlan: React.Dispatch<any>,
    handleHallSelectedEvent: (hallID: number, checked: boolean) => void,
}> = ({
                                         hallWithFloorPlans,
                                         fetchFairDetails,
                                         setOpenFloorPlanModal,
                                         setSelectedFloorPlan,
                                         handleHallSelectedEvent,
                                         resetTrigger}
) => {

    const [open, setOpen] = React.useState(false);
    const [confirmDeleteDialogIsOpened, setConfirmDeleteDialogIsOpened] =
        useState(false);
    const [confirmExportDialogIsOpened, setConfirmExportDialogIsOpened] =
        useState(false);

    const [selectedFloorPlanIDName, setSelectedFloorPlanIDName] = useState<{
        id: number,
        name: string
    } | null>(null)

    const [checkBoxChecked, setCheckBoxChecked] = useState(true);

    const handleCheckBoxChange = (event: any) => {
        setCheckBoxChecked(event.target.checked);
    };

    useEffect(() => {
        setCheckBoxChecked(false)
    }, [resetTrigger]);

    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset'}}}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {hallWithFloorPlans.id}
                </TableCell>
                <TableCell align="left">{hallWithFloorPlans.name}</TableCell>
                <TableCell align="left">{hallWithFloorPlans.description}</TableCell>
                <TableCell align="right">
                    <Checkbox
                        sx={{marginRight: 5}}
                        onClick={(e) => {
                            //@ts-ignore
                            handleHallSelectedEvent(hallWithFloorPlans.id, e.target.checked)
                            //@ts-ignore
                            setCheckBoxChecked(e.target.checked)
                        }}
                        checked={checkBoxChecked}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Typography variant="h6" gutterBottom component="div">
                                Prostorni planovi
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell align="left">Naziv</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {hallWithFloorPlans.floorPlans.map((floorPlan: any) => (
                                        <TableRow key={floorPlan.id}>
                                            <TableCell component="th" scope="row">
                                                {floorPlan.id}
                                            </TableCell>
                                            <TableCell align="left">{floorPlan.name}</TableCell>
                                            <TableCell align="right">
                                                <Stack direction={"row"}
                                                       justifyContent="end"
                                                >
                                                    <Tooltip title="Otvori prostorni plan" arrow>
                                                        <IconButton
                                                            sx={{marginRight: 2}}
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                try {
                                                                    const response = await fetchFloorPlan(floorPlan.id)
                                                                    setSelectedFloorPlan(response?.floorPlan)
                                                                    setOpenFloorPlanModal(true);
                                                                } catch (error:any) {
                                                                    createToastNotification('error', error?.response?.data?.message);
                                                                }
                                                            }}
                                                        >
                                                            <VisibilityIcon color="primary"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Izvezi prostorni plan" arrow>
                                                        <IconButton
                                                            sx={{marginRight: 2}}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedFloorPlanIDName(
                                                                    {
                                                                        id: floorPlan.id,
                                                                        name: floorPlan.name
                                                                    }
                                                                )
                                                                setConfirmExportDialogIsOpened(true);
                                                            }}
                                                        >
                                                            <IosShareIcon color="primary"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Obriši prostorni plan" arrow>
                                                        <IconButton
                                                            sx={{marginRight: 1}}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedFloorPlanIDName(
                                                                    {
                                                                        id: floorPlan.id,
                                                                        name: floorPlan.name
                                                                    }
                                                                )
                                                                setConfirmDeleteDialogIsOpened(true);
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon color="error"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
            {confirmExportDialogIsOpened && (
                <ConfirmationModal
                    confirmationModalTitle="Izvoz prostornog plana"
                    cancelAction={() => {
                        setSelectedFloorPlanIDName(null);
                        setConfirmExportDialogIsOpened(false);
                    }}
                    handleAction={async () => {
                        if (selectedFloorPlanIDName && selectedFloorPlanIDName.id) {
                            try {
                                const svgResponse = await exportFloorPlan(selectedFloorPlanIDName.id);
                                const blob = await svgResponse.blob();
                                let svgFile = new File([blob], `${selectedFloorPlanIDName.name}.svg`, {
                                    type: 'application/octet-stream',
                                });
                                const url = URL.createObjectURL(svgFile);
                                const a = document.createElement("a");
                                a.href = url;
                                a.download = svgFile.name;
                                a.click();
                                URL.revokeObjectURL(url);
                                await fetchFairDetails();
                                createToastNotification('success', 'Prostorni plan je uspešno izvezen');
                            } catch (error: any) {
                                createToastNotification('error', error?.response?.data?.message);
                            }
                        }
                        setSelectedFloorPlanIDName(null);
                        setConfirmExportDialogIsOpened(false);
                    }
                    }
                    confirmBtnTitle="Potvrdi"
                    modalDescription="Da li ste sigurni da želite da izvezete prostorni plan u SVG?"
                    cancelBtnTitle="Odustani"
                />
            )}
            {confirmDeleteDialogIsOpened && (
                <ConfirmationModal
                    confirmationModalTitle="Brisanje prostornog plana"
                    cancelAction={() => {
                        setSelectedFloorPlanIDName(null);
                        setConfirmDeleteDialogIsOpened(false)
                    }}
                    handleAction={async () => {
                        if (selectedFloorPlanIDName && selectedFloorPlanIDName.id) {
                            try {
                                await deleteFloorPlan(selectedFloorPlanIDName.id);
                                await fetchFairDetails();
                                createToastNotification('success', 'Prostorni plan je uspešno obrisan');
                            } catch (error: any) {
                                createToastNotification('error', error?.response?.data?.message);
                            }
                        }
                        setSelectedFloorPlanIDName(null);
                        setConfirmDeleteDialogIsOpened(false);
                    }
                    }
                    confirmBtnTitle="Potvrdi brisanje"
                    modalDescription="Da li ste sigurni da želite da obrišete prostorni plan?"
                    cancelBtnTitle="Odustani"
                />
            )}
        </React.Fragment>
    );

}
